import React from "react";
import {
  Text,
  Image,
  withSitecoreContext,
  RichText,
  isEditorActive,
  Link,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { CardLinkModel } from "./models/CardLink.model";
import { CardLinkProps } from "./types/CardLink.types";
import LazySection from "../../react-only-components/LazySection";
import { anchorWithId } from "../../helpers/anchorWithId.helper";

const CardLink = (props: CardLinkProps) => {
  const model = new CardLinkModel(props);

  const getCardHeight = () => {
    return props?.fields?.summarycards.map(
      (item, i) => +(item?.fields?.cardheight?.value ?? '')
    );
  };

  const horizontalLineCount = (index) => {
    let count = 0;
    let row = 0;
    let cardheight = getCardHeight()?.[index] ?? 0;
    let HorizontalLine = props?.fields?.summarycards[
      index
    ]?.fields?.linkgroups?.forEach((item, i) => {
      if (row <= cardheight) {
        if (item?.fields?.title?.value) {
          row = row + 1;
        }
        if (
          (item?.fields?.noofcolumns?.value?.toLowerCase() !== "one" ||
            item?.fields?.noofcolumns?.value.toLowerCase() !== "") &&
          row <= cardheight
        ) {
          row = row + 1;
          if (
            item?.fields?.displayhoizontalseperation?.value === true &&
            row <= cardheight
          ) {
            count = count + 1;
          }
        }
        if (
          (item?.fields?.noofcolumns?.value?.toLowerCase() === "one" ||
            item?.fields?.noofcolumns?.value?.toLowerCase() === "") &&
          row <= cardheight
        ) {
          if (
            item?.fields?.displayhoizontalseperation?.value === true &&
            row <= cardheight
          ) {
            count = count + 1;
          }
        }
      }
    });
    return count;
  };

  const finalCardHeight = (index) => {
    let cardHeight =
      14.5 * horizontalLineCount(index) +
      24 * (getCardHeight()?.[index] ?? 0) +
      14 * (getCardHeight()?.[index] ?? 0);
    return cardHeight;
  };
  const finalCardWrapperHeight = (index) => {
    let cardFinalHeight =
      47 +
      14.5 * horizontalLineCount(index) +
      24 * (getCardHeight()?.[index] ?? 0) +
      14 * (getCardHeight()?.[index] ?? 0);
    return cardFinalHeight;
  };

  const wrapperHeight = (index) => {
    return { height: finalCardWrapperHeight(index) };
  };
  const height = (index) => {
    return { height: finalCardHeight(index) };
  };

  return (
    <LazySection height={100} id={props?.rendering?.uid}>
      {props?.fields && (
        <div className="card-link-wrapper">
          <RichText
            field={model.fields?.title}
            className="card-link-title"
            tag="h2"
          />

          <div className="summary-card-list">
            {model?.fields?.summarycards?.map((item, i) => (
              <div
                className={`summary-card-wrapper ${
                  i === (model?.fields?.summarycards?.length ?? 0) - 1 ? "lastCard" : ""
                }`}
                style={wrapperHeight(i)}
                key={i}
              >
                <div className="summary-card" style={height(i)}>
                  {item?.fields?.linkgroups?.map((linkItem, j) => (
                    <>
                      <RichText
                        field={linkItem?.fields?.title}
                        className="summary-card-title custom-count-check"
                        tag="h2"
                      />

                      <ul
                        key={j}
                        className={[
                          linkItem?.fields?.displayhoizontalseperation
                            ?.value === true
                            ? "horizontal-line"
                            : "",
                          linkItem?.fields?.noofcolumns?.value === "one" ||
                          linkItem?.fields?.noofcolumns?.value === ""
                            ? "single-column"
                            : "multi-column",
                        ].join(" ")}
                      >
                        {linkItem?.fields?.links?.map((item, i) => (
                          <>
                            {item?.fields?.link?.value?.href && (
                              <li
                                key={i}
                                className={[
                                  linkItem?.fields?.noofcolumns?.value ===
                                    "one" ||
                                  linkItem?.fields?.noofcolumns?.value === ""
                                    ? ""
                                    : linkItem?.fields?.noofcolumns?.value ===
                                      "two"
                                    ? "coloumn-align two"
                                    : linkItem?.fields?.noofcolumns?.value ===
                                        "three" && "coloumn-align three",
                                ].join(" ")}
                              >
                                {item?.fields?.link?.value?.href && (
                                  <>
                                    {isEditorActive() ? (
                                      <Link field={item?.fields?.link}>
                                        <Text
                                          field={item?.fields?.linklabel}
                                          tag="span"
                                        />
                                        {
                                          <Image
                                            className="image-dimension"
                                            field={
                                              item?.fields?.linkicontype?.fields
                                                ?.Icon
                                            }
                                            alt={
                                              item?.fields?.linkicontype?.fields
                                                ?.Icon?.value?.alt
                                            }
                                          />
                                        }
                                      </Link>
                                    ) : (
                                      <a
                                        href={anchorWithId(
                                          item?.fields?.link?.value?.href,
                                          item?.fields?.link?.value?.anchor
                                        )}
                                        target={item?.fields?.linktarget?.value}
                                        download={
                                          item?.fields?.linktarget?.value ===
                                          "_prompt"
                                        }
                                      >
                                        <Text
                                          field={item?.fields?.linklabel}
                                          tag="span"
                                        />
                                        {
                                          <Image
                                            className="image-dimension"
                                            field={
                                              item?.fields?.linkicontype?.fields
                                                ?.Icon
                                            }
                                            alt={
                                              item?.fields?.linkicontype?.fields
                                                ?.Icon?.value?.alt
                                            }
                                          />
                                        }
                                      </a>
                                    )}
                                  </>
                                )}

                                <div
                                  className={[
                                    item?.fields?.displayverticalseperation
                                      ?.value === true &&
                                    linkItem?.fields?.noofcolumns?.value !==
                                      "one"
                                      ? "vertical-line"
                                      : "",
                                    linkItem?.fields?.noofcolumns?.value ===
                                      "one" ||
                                    linkItem?.fields?.noofcolumns?.value === ""
                                      ? ""
                                      : linkItem?.fields?.noofcolumns?.value ===
                                        "two"
                                      ? "coloumn-align two"
                                      : linkItem?.fields?.noofcolumns?.value ===
                                          "three" && "coloumn-align three",
                                  ].join(" ")}
                                ></div>
                              </li>
                            )}
                          </>
                        ))}
                      </ul>
                    </>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </LazySection>
  );
};

export default withSitecoreContext()(CardLink);
